export default __webpack_public_path__ + "static/media/tiny_mce_sample.5753a6f2.png";